module.exports = __webpack_public_path__ + "static/img/16.c347f71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/zh/16.png
// module id = eEUE
// module chunks = 0